
import React from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";

const BfFormstep32 = ({lang, setLang, nextStep, backStep, updateFormData, formData, vehicleIndexToEdit, vehicleIndexToDisplay, setVehicleIndexToEdit, vehicleDisplayIndex}) => {  
  const handleNumberInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter out non-number characters
    const numbersOnlyValue = inputValue.replace(/[^0-9]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, numbersOnlyValue);
  }
  const handleMoneyInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Remove non-numeric characters and leading zeros
    const cleanedValue = inputValue.replace(/[^0-9]/g, '').replace(/^0+/, '');
  
    // Format the cleaned value with commas
    const formattedValue = cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Update the formik value with the formatted value
    formik.setFieldValue(fieldName, formattedValue);
  }
  
  const handleAlphanumInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter to allow only letters, numbers, and hyphen
    const alphanumValue = inputValue.replace(/[^a-zA-Z0-9- ]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, alphanumValue);
  }
  const handleVINChange = (e, fieldName) => {
  // Extract the input value
  const inputValue = e.target.value;

  // Filter to allow only letters, numbers, and hyphen, and convert to uppercase
  const vinValue = inputValue.replace(/[^a-zA-Z0-9- ]/g, '').toUpperCase();

  // Update the formik value with the filtered value
  formik.setFieldValue(fieldName, vinValue);
}
  
  const handleLetterInputChange = (e, fieldName) => {
    // Extract the input value
    const inputValue = e.target.value;
  
    // Filter out non-letter characters
    const lettersOnlyValue = inputValue.replace(/[^a-zA-Z   ]/g, '');
  
    // Update the formik value with the filtered value
    formik.setFieldValue(fieldName, lettersOnlyValue);
  }
  const setIndexToNull = () => {
    setVehicleIndexToEdit(null);
  }
  const defaultVehicleValues = {
    year: '',
    make: '',
    model: '',
    vin: '',
    radius_operation: '',
    value: ''
};

let initialValues = { ...defaultVehicleValues };

if (formData.step32 && vehicleIndexToEdit !== null) {
    initialValues = {
        year: formData.step32[`vehicles[${vehicleIndexToEdit}]year`] || '',
        make: formData.step32[`vehicles[${vehicleIndexToEdit}]make`] || '',
        model: formData.step32[`vehicles[${vehicleIndexToEdit}]model`] || '',
        vin: formData.step32[`vehicles[${vehicleIndexToEdit}]vin`] || '',
        radius_operation: formData.step32[`vehicles[${vehicleIndexToEdit}]radius_operation`] || '',
        value: formData.step32[`vehicles[${vehicleIndexToEdit}]value`] || ''
    };
  
}
const messages = {
  min: lang === 'eng' ? "Please enter at least 2 characters" : "Por favor, ingrese al menos 2 caracteres",
  required: lang === 'eng' ? "This field is required." : "Este campo es obligatorio."
};

const validationSchema = Yup.object().shape({
  year: Yup.string().required(messages.required),
  make: Yup.string()
    .min(2, messages.min)
    .required(messages.required),
  model: Yup.string()
    .min(2, messages.min)
    .required(messages.required),
  vin: Yup.string()
    .min(2, messages.min)
    .required(messages.required),
  radius_operation: Yup.string()
    .min(2, messages.min)
    .required(messages.required),
  value: Yup.string()
    .min(2, messages.min),
});



  const formik = useFormik({

    initialValues: initialValues,

    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateFormData(values);
      nextStep();
    },

  });
  return (
    
<>

<>
  <header className="c-site-header">
    <a className="c-site-header__skip js-site-header-skip" href="#main">
      Skip to main content
    </a>
    <div className="o-wrapper">
      <a
        className="c-site-header__logo-link"
        href="./"
        aria-label="Go to home page"
      >
        <img
          className="c-site-header__logo"
          src="images/components/site-header/logo-blf-specialty.svg"
          alt="Bluefire Specialty Logo"
          width={100}
          height={34}
        />
      </a>
      <h1 className="c-site-header__title">
       <span className="o-icon-vehicles">
      <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-vehicle" />
            </svg>
</span>

          {lang === 'eng' ? 'Vehicles Information' : 'Información de vehículos'}
        </h1>
      <div className="c-site-header__controls c-header-controls">
      <button 
    className="c-header-controls__language" 
    onClick={() => setLang(lang === 'eng' ? 'spa' : 'eng')}  // Toggle the language
  >
    <span className="o-icon c-header-controls__icon">
      <svg aria-hidden="true" focusable="false" role="img">
        <use href="images/icons/icons.svg#icon-language" />
      </svg>
    </span>
    <span className="u-hidden-visually">
      {lang === 'eng' ? 'Switch to Spanish' : 'Switch to English'}
    </span>
    <span className="c-header-controls__text">
      {lang === 'eng' ? 'Español' : 'English'}
    </span>
  </button>
      </div>
    </div>
  </header>
  <main className="c-main-content">
    <div className="c-section">
      <div className="o-wrapper o-wrapper--small">
      <h1 className="c-section__title">
      <span className="o-icon-vehicles">
      <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-vehicle" />
            </svg>
</span>
          {lang === 'eng' ? 'Vehicles Information' : 'Información de vehículos'}
        </h1>
        <div className="c-section__content">
          <div className="c-steps">
            <ul className="o-list-bare c-steps__list">
              <li className="o-list-bare__item c-steps__item c-steps__item--100 c-steps__step--completed">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Applicant' : 'Solicitante'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item  c-steps__step--completed">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Drivers' : 'Conductores'} </div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item c-steps__item--50 c-steps__step--active">
                <div className="c-steps__step c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Vehicles' : 'Vehículos'}</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                  <div className="c-steps__text">{lang === 'eng' ? 'Documents' : 'Documentos' }</div>
                  <div className="c-steps__circle" />
                </div>
              </li>
              <li className="o-list-bare__item c-steps__item">
                <div className="c-steps__step">
                <div className="c-steps__text">{lang === 'eng' ? 'Finish' : 'Finalizar' }</div>                  <div className="c-steps__circle" />
               
                </div>
              </li>
            </ul>
          </div>
          <div className="c-content">
            <div className="c-adding">
              <h2 className="c-adding__title">Adding New Vehicle</h2>
              <div className="c-adding__text">
                <p>
                  You can add up to 45 drivers. If you need more, please contact
                  us at <a href="tel:888-851-5070">888-851-5070</a>
                </p>
                <p>Click here to add Vehicles. </p>
              </div>
              <div className="c-adding__control">
                <button className="c-button c-button--blue" type="button">
                  <span className="o-icon">
                    <svg aria-hidden="true" focusable="false" role="img">
                      <use href="images/icons/icons.svg#icon-plus" />
                    </svg>
                  </span>
                  Add Vehicles
                </button>
              </div>
              <div className="c-adding__image">
                <img
                  src="images/components/ima-add.svg"
                  aria-hidden="true"
                  width={240}
                  height={167}
                />
              </div>
            </div>
            <div className="c-quote__controls">
              <button
                className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                type="button"
              >
                {lang === 'eng'? 'Previous' : 'Atrás'}
              </button>
              <button
                className="c-quote__control c-quote__control--submit c-button c-button--disabled"
                type="button"
         
              >
                {lang === 'eng'? 'Continue' : 'Continuar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div
    className="c-modal-quote is-open"
    role="dialog"
    aria-modal="true"
    aria-label="Get a Quick Quote"
  >
    <div className="c-modal-quote__overlay" />
    <div className="o-wrapper o-wrapper">
      <div className="c-modal-quote__content">
        <div className="c-modal-quote__title">
          <span className="o-icon">
            <svg aria-hidden="true" focusable="false" role="img">
              <use href="images/icons/icons.svg#icon-plus" />
            </svg>
          </span>
          <h2>{lang === 'eng' ? 'Add Vehicle' : 'Agregar vehículo'}</h2>
        </div>
        <div className="c-quote">



          <form onSubmit={formik.handleSubmit} className="c-quote__form js-form" noValidate>
            <h2 className="c-quote__title">
          
              {lang === 'eng' ? 'Vehicle' : 'Vehículo'} No. {vehicleIndexToEdit !== null ? vehicleIndexToDisplay : vehicleDisplayIndex}
            </h2>

  
                {/* year*/}
                <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.year && formik.errors.year ? 'c-quote-error' : ''}`}>
    <label className="c-quote__label" htmlFor="year">
       {lang === 'eng' ? 'Year' : 'Año'} 
    </label>
    <select
        className={`c-quote__select ${formik.touched.year && formik.errors.year ? 'js-form-error' : ''}`}
        id="year"
        name="year"
        required
        aria-required="true"
        aria-invalid={formik.touched.year && formik.errors.year ? 'true' : 'false'}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.year}
    >
        <option value="">
          {lang === 'eng' ? 'Select Year' : 'Selecciona año'}
        </option>
        {
    Array.from({ length: (new Date().getFullYear() - 1949) + 1 }, (_, i) => new Date().getFullYear() - i + 1)
    .map(year => <option key={year} value={year}>{year}</option>)
}
    </select>
    {formik.touched.year && formik.errors.year ? (
        <label id="year-error" className="js-form-error" htmlFor="year">
            {formik.errors.year}
        </label>
    ) : null}
</div>



             {/* make */}
             <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.make && formik.errors.make ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="make">
                      {lang === 'eng' ? 'Make' : 'Selecciona marca'}   
                    </label>
                    <input
                      className={`c-quote__input only-letters ${formik.touched.make && formik.errors.make ? 'js-form-error' : ''}`}
                      id="make"
                      type="text"
                      name="make"
                      maxLength={50}
                      minLength={2}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.make && formik.errors.make ? 'true' : 'false'}
                      onChange={e => handleLetterInputChange(e, 'make')}
                      onBlur={formik.handleBlur}
                      value={formik.values.make}
                    />
                    {formik.touched.make && formik.errors.make ? (
                      <label id="make-error" className="js-form-error" htmlFor="make">
                        {formik.errors.make}
                      </label>
                    ) : null}
                  </div>



                  {/* Model */}
                  <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.model && formik.errors.model ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="model">
                      {lang === 'eng' ? 'Model' : 'Selecciona modelo'}
                    </label>
                    <input
                      className={`c-quote__input ${formik.touched.model && formik.errors.model ? 'js-form-error' : ''}`}
                      id="model"
                      type="text"
                      name="model"
                      maxLength={50}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.model && formik.errors.model ? 'true' : 'false'}
                      onChange={e => handleAlphanumInputChange(e, 'model')}
                      onBlur={formik.handleBlur}
                      value={formik.values.model}
                    />
                    {formik.touched.model && formik.errors.model ? (
                      <label id="model-error" className="js-form-error" htmlFor="model">
                        {formik.errors.model}
                      </label>
                    ) : null}
                  </div>

            <div className="c-quote__item c-quote__item--empty" />


            {/* vin */}
          
            <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.vin && formik.errors.vin ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="vin">
                      VIN   
                    </label>
                    <input
                      className={`c-quote__input ${formik.touched.vin && formik.errors.vin ? 'js-form-error' : ''}`}
                      id="vin"
                      type="text"
                      name="vin"
                      maxLength={18}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.vin && formik.errors.vin ? 'true' : 'false'}
                      onChange={e => handleVINChange(e, 'vin')}
                      onBlur={formik.handleBlur}
                      value={formik.values.vin}
                    />
                    {formik.touched.vin && formik.errors.vin ? (
                      <label id="vin-error" className="js-form-error" htmlFor="vin">
                        {formik.errors.vin}
                      </label>
                    ) : null}
                  </div>



        {/* Radius of op */}
        <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.radius_operation && formik.errors.radius_operation ? 'c-quote-error' : ''}`}>
  <label className="c-quote__label" htmlFor="radius_operation">
    {lang === 'eng' ? 'Radius of Operation' : 'Radio de operación'}
  </label>
  <input
    type="text"
    className={`c-quote__input ${formik.touched.radius_operation && formik.errors.radius_operation ? 'js-form-error' : ''}`}
    id="radius_operation"
    name="radius_operation"
    required
    aria-required="true"
    aria-invalid={formik.touched.radius_operation && formik.errors.radius_operation ? 'true' : 'false'}
    onChange={(e=> handleAlphanumInputChange(e, 'radius_operation'))}
    onBlur={formik.handleBlur}
    value={formik.values.radius_operation}
  />
  {formik.touched.radius_operation && formik.errors.radius_operation ? (
    <label id="radius_operation-error" className="js-form-error" htmlFor="radius_operation">
      {formik.errors.radius_operation}
    </label>
  ) : null}
</div>
               {/* Value */}
               <div className={`c-quote__item c-quote__item--50 c-quote__item--m100 ${formik.touched.value && formik.errors.value ? 'c-quote-error' : ''}`}>
                    <label className="c-quote__label" htmlFor="value">
                      {lang === 'eng' ? 'Vehicle Value' : 'Valor del Vehículo'}
                    </label>
                    <div className="c-quote__disclaimer">
    {lang === 'eng' ? 'Add only if physical damage is requested.' : 'Agregar solo si se reportan daños al vehículo'}
  </div>
                    <input
                      className={`c-quote__input ${formik.touched.value && formik.errors.value ? 'js-form-error' : ''}`}
                      id="value"
                      type="text"
                      name="value"
                      maxLength={50}
                      required
                      aria-required="true"
                      aria-invalid={formik.touched.value && formik.errors.value ? 'true' : 'false'}
                      onChange={e => handleMoneyInputChange(e, 'value')}
                      onBlur={formik.handleBlur}
                      value={formik.values.value}
                    />
      
                    {formik.touched.value && formik.errors.value ? (
                      <label id="value-error" className="js-form-error" htmlFor="value">
                        {formik.errors.value}
                      </label>
                    ) : null}
                  </div>

     
     
            <div className="c-quote__controls">
              <button
                className="c-quote__control c-quote__control--previous c-button c-button--linear-indingo"
                type="button"
                onClick={() => {
                  setIndexToNull();
                  backStep();
              }}
              >
                {lang === 'eng' ? 'Discard' : 'Borrar'}
              </button>
              <button
                className="c-quote__control c-quote__control--submit c-button c-button--blue-light"
                type="submit"
              >
                {lang === 'eng' ? 'Save' : 'Guardar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <footer className="c-site-footer">
    <div className="o-wrapper">
      <div className="c-site-footer__legal">
        <p className="c-site-footer__legal_text">
          © 2023 Bluefire Insurance Services Inc.
          <br />
          {lang === 'eng' ? <>List Of Entity/License Numbers Per State Located On  <br/></> : <>Listado de entidades/números de licencia por estado <br /> localizada en nuestra página de</>}  
  <a href="https://www.bluefireinsurance.com/affiliate-disclosure/" target="_blank" rel="noopener noreferrer">
    {lang === 'eng'? "Affiliate Disclosure Page." : " Aviso de Nuestras Filiales"} 
  </a>

        </p>
          <ul className="o-list-bare c-site-footer__legal_links">
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
      { lang=== 'eng' ? ` Privacy Policy` : `Políticas de privacidad`}
    </a>
  </li>
  {window.innerWidth <= 768 && lang !== 'eng' ? (
    <>
      <li className="o-list-bare__item c-site-footer__legal-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del"}
        </a>
      </li>
      <li className="o-list-bare__item c-site-footer__legal-link spanish-consumer-link">
        <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
          {lang === 'eng' ? "" : "Consumidor de California"}
        </a>
      </li>
    </>
  ) : (
    <li className="o-list-bare__item c-site-footer__legal-link ">
      <a href="https://www.bluefireinsurance.com/california-consumer-privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'normal' }}>
        {lang === 'eng' ? "California Consumer Privacy Policy" : "Política de Privacidad del Consumidor de California"}
      </a>
    </li>
  )}
  <li className="o-list-bare__item c-site-footer__legal-link">
    <a href="https://www.bluefireinsurance.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
      {lang === 'eng' ? " Terms of Use" : "Condiciones de uso"}
    </a>
  </li>
</ul>
      </div>
    </div>
  </footer>
</>


</>
  );
} 

export default BfFormstep32;